var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"cm-link",class:[
    _vm.customClass,
    {
      'link-secondary': !_vm.isActive,
      'link-primary': _vm.isActive,
      'is-active': _vm.isActive,
    } ],attrs:{"to":_vm.to},nativeOn:{"click":function($event){return _vm.onClickLink.apply(null, arguments)}}},[_vm._t("icon"),_c('p',{staticClass:"cm-link__text"},[_vm._t("default")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }